import transformUTCToLocale from 'utils/transformUTCToLocale'

export const createAdSpotStatus = (last_activity?: string | null) => {
  if (last_activity) {
    if (Date.now() - transformUTCToLocale(last_activity).getTime() > 1000 * 60 * 60 * 24 * 7) {
      return 2
    }
    if (Date.now() - transformUTCToLocale(last_activity).getTime() < 1000 * 60 * 60 * 24 * 2) {
      return 1
    }
    if (Date.now() - transformUTCToLocale(last_activity).getTime() > 1000 * 60 * 60 * 24 * 2) {
      return 0
    }
  }
  return 2
}
